import { Section } from '@/modules/tools/bankruptcy/components/CasePage/ScreeningBreakdown/Section'
import type { ScreeningVersion } from '@/modules/tools/bankruptcy/stores/types'
import { humanizeDate } from '@/utils'

export const VersionList = ({ versions }: { versions: ScreeningVersion[] }) => {
  if (versions.length === 0) return null

  return (
    <Section
      title="Screening runs"
      hint="Every run kept for this case, newest first."
    >
      <ul className="divide-y text-sm">
        {versions.map((version) => (
          <li key={version.id} className="flex justify-between py-2">
            <span>{humanizeDate(version.createdAt)}</span>
            <span className="text-ink-subtle">{version.status}</span>
          </li>
        ))}
      </ul>
    </Section>
  )
}
